import {decode as base64_decode, encode as base64_encode} from 'base-64';
import RootStore from './RootStore';
import { postApi,baseURL } from '../components/Utility'
import {
  action,
  
  makeObservable,
  observable,
 
} from 'mobx';


class UserLoginReportStore {
  userLoginReport=[]
  total=0
  loading=false
  rootStore
  rec=0

  constructor(rootStore) {
    makeObservable(this, {
        userLoginReport: observable,
      total:observable,
      loading:observable,
      rec:observable,
      loadData:action,
      exportExcel:action,
      exportcsv:action,
      exportpdf:action,
      exportxml:action
     
    });
     this.rootStore = rootStore;
    
  }

  async loadData({offset,limit,companyId,fromDate,toDate,userId}) {
    console.log("userId",userId)
    this.loading=true
    var postData = {"companyId":companyId,"userid":userId,"fromDate":fromDate,"toDate":toDate,"offset":offset,"limit":limit,"page":1}
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=vehicle&a=loginreport", "postData="+base64Input);
    console.log("userlogingreport " ,response?.data?.data)
   
    this.userLoginReport =response?.data?.data?.loginreport
    if(this.userLoginReport.length >0){
      this.rec=1
    }
     this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading=false;
  }
  async exportExcel(getDta){
    window.location.href = baseURL + "index.php?c=vehicle&a=exportloginexcel&cid=" +getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + '&uId=' + getDta.userId + '&colList=' + getDta.colList
  
  }
  async exportpdf(getDta){
    window.location.href = baseURL + "index.php?c=vehicle&a=exportloginpdf&cid=" +getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + '&uId=' + getDta.userId + '&colList=' + getDta.colList
   
  }
  async exportcsv(getDta){
    window.location.href = baseURL + "index.php?c=vehicle&a=exportlogincsv&cid=" +getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + '&uId=' + getDta.userId + '&colList=' + getDta.colList
  }
  async exportxml(getDta){
    window.location.href = baseURL + "index.php?c=vehicle&a=exportloginxml&cid=" +getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + '&uId=' + getDta.userId + '&colList=' + getDta.colList
  }

}

export default UserLoginReportStore;
